import { useTranslation } from 'react-i18next'

import { FormikField, getFormikFormFieldErrorProps } from '../../Formik'
import { TextareaOutlineField } from '../../Textarea'

import {
  NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_FIELD_MIN_ROWS,
  NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_FIELD_NAME,
} from './NewsboardPostProfileHeaderEditTitleField.constants'
import { getNewsboardPostProfileHeaderEditTitleMaxLength } from './NewsboardPostProfileHeaderEditTitleField.utils'

function NewsboardPostProfileHeaderEditTitleField({ ticker, ...restProps }) {
  const { t } = useTranslation()

  return (
    <FormikField
      {...restProps}
      autoFocus
      clearable
      withoutManualResize
      Component={TextareaOutlineField}
      getErrorProps={getFormikFormFieldErrorProps}
      label={t('NewsboardPostProfile.EditTitleFieldLabelKey')}
      maxLength={getNewsboardPostProfileHeaderEditTitleMaxLength(ticker)}
      minRows={NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_FIELD_MIN_ROWS}
      name={NEWSBOARD_POST_PROFILE_HEADER_EDIT_TITLE_FIELD_NAME}
      placeholder={t('NewsboardPostProfile.EditTitleFieldPlaceholderKey')}
    />
  )
}

export default NewsboardPostProfileHeaderEditTitleField
